import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card w-100 loading-background" }
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 0,
  class: "carousel-indicators --carousel-bottom-indicators mb-0"
}
const _hoisted_4 = ["data-bs-target", "data-bs-slide-to", "aria-label"]
const _hoisted_5 = { class: "carousel-inner h-100" }
const _hoisted_6 = ["id", "data-bs-interval"]
const _hoisted_7 = {
  key: 0,
  class: "h-100 w-100"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "" }
const _hoisted_10 = {
  colspan: "3",
  class: "p-0 border-none overflow-shown"
}
const _hoisted_11 = { class: "leaderboard-header position-relative" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "position-absolute start-0 top-100 translate-middle-y pb-4 ms-5 h5 fw-bold" }
const _hoisted_14 = {
  scope: "row",
  class: "ps-3 pe-3 text-center"
}
const _hoisted_15 = { class: "pe-0" }
const _hoisted_16 = { class: "d-flex align-items-center position-relative text-nowrap" }
const _hoisted_17 = { class: "leader-name position-relative w-100 lh-1 ps-4 py-1 small" }
const _hoisted_18 = { class: "text-dark fw-bold" }
const _hoisted_19 = { class: "small text-muted" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "ps-0 pe-4" }
const _hoisted_22 = { class: "leaderboard-count d-flex align-items-center justify-content-center me-4 w-100" }
const _hoisted_23 = { class: "text-center fw-bold fs-5 lh-2 text-dark rounded-pill rounded-start flex-grow-1" }
const _hoisted_24 = {
  scope: "row",
  class: "ps-3 pe-3 text-center"
}
const _hoisted_25 = { class: "" }
const _hoisted_26 = {
  colspan: "4",
  class: "text-center small mt-4"
}
const _hoisted_27 = { class: "mt-2 mb-3 small" }
const _hoisted_28 = { class: "fw-bold lh-1" }
const _hoisted_29 = ["data-bs-target"]
const _hoisted_30 = ["data-bs-target"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rank_icon = _resolveComponent("rank-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: 'leaderboardCarousel-' + _ctx.id,
      class: "carousel carousel-slide slide loading-background w-100 h-100",
      "data-bs-ride": "carousel"
    }, [
      (_ctx.leaderboards.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leaderboards, (img, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: index,
                type: "button",
                "data-bs-target": '#leaderboardCarousel-' + _ctx.id,
                class: _normalizeClass({ active: index === _ctx.activeSlide }),
                "data-bs-slide-to": index,
                "aria-label": 'Slide ' + index
              }, null, 10, _hoisted_4))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leaderboards, (l, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            id: '#' + l._id,
            class: _normalizeClass(["h-100", 'carousel-item' + (index * 1 === 0 ? ' active' : '')]),
            "data-bs-interval": l.interval ?? 8000
          }, [
            (l._type === 'static')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("img", {
                    src: l.staticImage,
                    class: "d-block w-100 h-100 rounded",
                    style: {"object-fit":"cover"},
                    alt: ""
                  }, null, 8, _hoisted_8)
                ]))
              : (_openBlock(), _createElementBlock("table", {
                  key: 1,
                  class: "table table-borderless align-middle table-sm text-white mb-0 rounded h-100",
                  style: _normalizeStyle(
                  'background-image: url(' +
                  l.backgroundImage +
                  '); background-size: cover; background-position: center;'
                )
                }, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_9, [
                      _createElementVNode("th", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("img", {
                            src: l.headerImage,
                            alt: "",
                            class: "img-fluid rounded-top"
                          }, null, 8, _hoisted_12),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(l.leaderboardName), 1)
                        ])
                      ])
                    ]),
                    _cache[0] || (_cache[0] = _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        scope: "col",
                        class: "ps-2 text-center"
                      }, "#"),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "ps-3"
                      }, "Usuario"),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "ps-0 pe-4 text-center"
                      }, [
                        _createElementVNode("div", { class: "" }, "Firmas")
                      ])
                    ], -1))
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(l.leaderboardEntries, (entry) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: entry.username,
                        class: ""
                      }, [
                        _createElementVNode("th", _hoisted_14, _toDisplayString(entry.position), 1),
                        _createElementVNode("td", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_18, _toDisplayString(entry.nickname), 1),
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_rank_icon, {
                                    "icon-class": _ctx.rankIconClass(entry.rankId),
                                    "extra-class": "ps-2 pe-1 small"
                                  }, null, 8, ["icon-class"]),
                                  _createTextVNode(_toDisplayString(_ctx.rankName(entry.rankId)), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("img", {
                              src: entry.profilePicture,
                              class: "avatar avatar-sm rounded-circle img-fluid border position-absolute translate-middle-x gtr-avatar-bg"
                            }, null, 8, _hoisted_20)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, _toDisplayString(entry.count), 1)
                          ])
                        ])
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(l.leaderboardEntries.length < 10
                      ? 10 - l.leaderboardEntries.length
                      : 0, (emptyRow) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: emptyRow,
                        class: ""
                      }, [
                        _createElementVNode("th", _hoisted_24, _toDisplayString(emptyRow + l.leaderboardEntries.length), 1),
                        _cache[1] || (_cache[1] = _createElementVNode("td", { class: "pe-0" }, [
                          _createElementVNode("div", { class: "d-flex align-items-center position-relative text-nowrap" }, [
                            _createElementVNode("div", { class: "leader-name position-relative w-100 lh-1 ps-4 py-1 small" }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", { class: "text-dark fw-bold" }),
                                _createElementVNode("div", { class: "small text-muted" }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(' ps-2 pe-1 small')
                                  })
                                ])
                              ])
                            ]),
                            _createElementVNode("div", { class: "empty-avatar avatar avatar-sm rounded-circle img-fluid border position-absolute translate-middle-x" })
                          ])
                        ], -1)),
                        _cache[2] || (_cache[2] = _createElementVNode("td", { class: "ps-0 pe-4" }, [
                          _createElementVNode("div", { class: "leaderboard-count d-flex align-items-center justify-content-center me-4 w-100" }, [
                            _createElementVNode("div", { class: "text-center fw-bold fs-5 lh-2 text-dark rounded-pill rounded-start flex-grow-1" })
                          ])
                        ], -1))
                      ]))
                    }), 128)),
                    _createElementVNode("tr", _hoisted_25, [
                      _createElementVNode("td", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _cache[3] || (_cache[3] = _createTextVNode("Fecha de Actualización: ", -1)),
                          _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.formatDateTimezone(l.dateUpdated.getTime())), 1)
                        ])
                      ])
                    ]),
                    _cache[4] || (_cache[4] = _createElementVNode("tr", null, null, -1))
                  ])
                ], 4))
          ], 10, _hoisted_6))
        }), 128))
      ]),
      (_ctx.leaderboards.length > 1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "carousel-control-prev w-auto",
            type: "button",
            "data-bs-target": '#leaderboardCarousel-' + _ctx.id,
            "data-bs-slide": "prev"
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("span", {
              class: "carousel-control-prev-icon",
              "aria-hidden": "true"
            }, null, -1),
            _createElementVNode("span", { class: "visually-hidden" }, "Previa", -1)
          ]))], 8, _hoisted_29))
        : _createCommentVNode("", true),
      (_ctx.leaderboards.length > 1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "carousel-control-next w-auto",
            type: "button",
            "data-bs-target": '#leaderboardCarousel-' + _ctx.id,
            "data-bs-slide": "next"
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("span", {
              class: "carousel-control-next-icon",
              "aria-hidden": "true"
            }, null, -1),
            _createElementVNode("span", { class: "visually-hidden" }, "Siguiente", -1)
          ]))], 8, _hoisted_30))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2)
  ]))
}